import { render, staticRenderFns } from "./LoginDialogBtn.vue?vue&type=template&id=dc462438&scoped=true"
import script from "./LoginDialogBtn.vue?vue&type=script&lang=js"
export * from "./LoginDialogBtn.vue?vue&type=script&lang=js"
import style0 from "./LoginDialogBtn.vue?vue&type=style&index=0&id=dc462438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc462438",
  null
  
)

export default component.exports